import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <p>&copy; 2024 Confident Group</p>
        {/* Updated the path to ensure it's correctly referencing the public folder */}
        <img src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="Confident Group Logo" className="footer-logo" />
      </footer>
    </div>
  );
};

export default Footer;
